module.exports = __webpack_public_path__ + "04_medium_brown.2915ec03.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_medium_brown.png
// module id = 2NIS
// module chunks = 0